"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _font = require("../constants/font");
/* eslint-disable @typescript-eslint/naming-convention -- css selectors */

/*
 * NOTE
 * Theme update in a project using createTheme that updates a color and/or a font definition will not affect definition here.
 * If you are overriding color definition (for example dark mode or a holyday theme) then you need to handle `a` and `hr` separately.
 * If your element is wrapped in ScopedCssBaseline, that will bring back automation.
 */

const styleOverrides = {
  // Body and Html
  html: {
    height: '100%',
    webkitTextSizeAdjust: '100%',
    webkitFontSmoothing: 'antialiased',
    mozOsxFontSmoothing: 'grayscale',
    fontSize: _constants.font.htmlFontSizeAdjust
  },
  body: {
    minHeight: '100%',
    margin: 0,
    overflow: 'auto',
    fontSize: '1.4rem'
  },
  a: {
    color: _constants.colors.text.primary,
    textDecoration: 'none'
  },
  [`a:hover,a:focus`]: {
    color: _constants.colors.text.hover
  },
  // Mostly action elements (button, a, audio, video, etc...)
  [`
  html,
  body,
  button,
  input,
  optgroup,
  select,
  textarea`]: {
    fontFamily: _font.fontFamily
  },
  [`
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  nav,
  section,
  summary,
  hr`]: {
    display: 'block'
  },
  [`
  audio,
  canvas,
  video`]: {
    display: 'inline-block'
  },
  [`audio:not([controls])`]: {
    display: 'none',
    height: 0
  },
  [`
  iframe,
  button`]: {
    border: 'none'
  },
  // Mostly text elements (h*, b, strong, hr, etc...)
  [`h1`]: {
    fontSize: '2em',
    margin: '.67em 0'
  },
  [`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6`]: {
    margin: 0,
    fontWeight: _font.fontWeightRegular
  },
  [`
  b,
  strong`]: {
    fontWeight: _font.fontWeightBold
  },
  [`blockquote`]: {
    margin: '1em 0 1em 40px'
  },
  [`hr`]: {
    height: 1,
    border: 0,
    borderTop: `1px solid ${_constants.colors.oriGrey[300]}`,
    padding: 0
  },
  [`hr,
  p,
  pre`]: {
    margin: '1em 0'
  },
  [`
  code,
  pre`]: {
    fontSize: '1rem',
    fontFamily: 'monospace, serif'
  },
  [`pre`]: {
    whiteSpace: 'pre-wrap'
  },
  [`small`]: {
    fontSize: '80%'
  },
  [`
  sub,
  sup`]: {
    fontSize: '75%',
    lineHeight: 0,
    position: 'relative',
    verticalAlign: 'baseline'
  },
  sup: {
    top: '-.5em'
  },
  sub: {
    bottom: '-.25em'
  },
  [`
  ol,
  ul`]: {
    margin: 0,
    padding: 0
  },
  [`
  nav ol,
  nav ul`]: {
    listStyle: 'none',
    listStyleImage: 'none'
  },
  // Mostly images, SVGs..
  img: {
    border: 0,
    verticalAlign: 'middle',
    maxWidth: '100%',
    height: 'auto'
  },
  'svg:not(:root)': {
    overflow: 'hidden'
  },
  // Mostly form controls & elements
  'label[for]': {
    cursor: 'pointer'
  },
  [`
  button,
  input,
  select,
  textarea`]: {
    fontSize: '1.6rem',
    margin: 0,
    verticalAlign: 'middle'
  },
  'button,input': {
    lineHeight: 'normal'
  },
  [`
  button,
  html input[type=button],
  input[type=reset],
  input[type=submit]`]: {
    webkitAppearance: 'button',
    cursor: 'pointer'
  },
  [`
  button[disabled],
  html input[disabled],
  input[disabled]`]: {
    cursor: 'default'
  },
  [`
  input[type=checkbox],
  input[type=radio]`]: {
    webkitBoxSizing: 'border-box',
    boxSizing: 'border-box',
    padding: 0
  },
  'input[type=text]::-ms-clear': {
    display: 'none'
  },
  textarea: {
    overflow: 'auto',
    verticalAlign: 'top'
  },
  [`
  button::-moz-focus-inner,
  input::-moz-focus-inner`]: {
    border: 0,
    padding: 0
  },
  'input[type=search]': {
    boxSizing: 'content-box',
    webkitAppearance: 'textfield',
    webkitBoxSizing: 'content-box'
  },
  // Other
  table: {
    borderCollapse: 'collapse',
    borderSpacing: 0
  },
  th: {
    fontWeight: _font.fontWeightRegular
  },
  [`
  body,
  button,
  figure`]: {
    margin: 0
  },
  // Scrollbar
  '@media (hover: hover) and (pointer: fine)': {
    '&, & *': {
      msOverflowStyle: '-ms-autohiding-scrollbar',
      scrollbarWidth: 'thin',
      scrollbarColor: `${_constants.colors.oriGrey[300]} transparent`
    },
    '::-webkit-scrollbar': {
      width: '15px',
      height: '15px'
    },
    '::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '::-webkit-scrollbar-thumb': {
      background: _constants.colors.oriGrey[300],
      borderRadius: '13px',
      border: '5px solid transparent',
      backgroundClip: 'content-box'
    }
  }
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiCssBaseline.js.map